import { AnyAction, configureStore, ThunkDispatch } from '@reduxjs/toolkit';

import magicMovieReducer from './magicMovie/magicMovieSlice';
import abTestExperimentReducer from './abTest/abTestingSlice';

export const store = configureStore({
  reducer: {
    ['magicMovie']: magicMovieReducer,
    ['abTestExperiment']: abTestExperimentReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch &
  ThunkDispatch<any, null, AnyAction> &
  ThunkDispatch<any, undefined, AnyAction>;
